<script setup lang="ts">
import { ref } from 'vue'
import UIKit from '@pocketprep/ui-kit'

const { Icon } = UIKit

const isShowingMobileWarning = ref(true)

const closeScreenWarning = () => {
    isShowingMobileWarning.value = false
}
</script>

<template>
    <div v-if="isShowingMobileWarning" class="mobile-screen-warning">
        <div class="mobile-screen-warning__message">
            Instructor Dashboard does not display properly on a smaller screen.
            For the best experience please switch to a laptop or desktop.
        </div>
        <Icon
            type="close"
            class="mobile-screen-warning__close-icon"
            title="Close"
            tabindex="0"
            @click="closeScreenWarning"
        />
    </div>
</template>

<style lang="scss" scoped>


.mobile-screen-warning {
    display: flex;
    justify-content: space-between;
    background-color: $cream-puff;
    border: 1px solid $banana-bread;
    width: 100%;

    &__message {
        font-size: 14px;
        font-weight: 500;
        line-height: 19px;
        padding: 20px 30px 20px 20px;
        color: $brand-black;
    }

    &__close-icon {
        margin: 8px 8px 0 0;
        height: 22px;
        width: 22px;
        min-width: 22px;
        cursor: pointer;
        color: $slate;
    }
}
</style>
